module.exports = __webpack_public_path__ + "img/Unidad-11.6db52d02.png";